export default __webpack_public_path__ + "static/per-marker-customisation-40fb85d1a8e52a0bf3cac25266e93511.png";